import routes from '@/routes/routes';
import store from '@/store';
import ROLES from '@/enums/Roles';

export const formatRoutes = (givenRoutes, parent) => {
  return givenRoutes.flatMap(route => {
    if (route.children) {
      return formatRoutes(route.children, route.path ? route.path : '');
    }

    return [
      {
        ...route,
        path: parent + route.path,
      },
    ];
  });
};

export const getRolesNeeded = to => {
  const routesFormatted = formatRoutes(routes, '');
  const toArray = to.path.split('/').filter(e => e !== '');
  const routesPossible = routesFormatted.filter(route => {
    const routeArray = route.path.split('/').filter(e => e !== '');
    return (
      routeArray.length === toArray.length &&
      !routeArray.find(
        (element, index) =>
          !element.startsWith(':') && element !== toArray[index],
      )
    );
  });
  return routesPossible.length > 0 ? routesPossible[0].permissions : null;
};

export const isUserAllowedByRoles = rolesNeeded => {
  const rolesUser = store.getters['account/roles'];
  return rolesNeeded.filter(role => rolesUser.includes(role)).length > 0;
};

export const isUserAllowedByLvl = rolesNeeded => {
  if (rolesNeeded.lvl === 0) {
    return true;
  }

  const rolesUser = store.getters['account/roles'];
  let isLvlEnough = false;
  rolesUser.forEach(role => {
    if (role.value >= rolesNeeded.lvl) {
      isLvlEnough = true;
    }
  });
  return isLvlEnough;
};

export const isAllowed = to => {
  const rolesNeeded = getRolesNeeded(to);

  // PERMISSION DEFINED BY ROLES
  if (rolesNeeded && rolesNeeded.roles) {
    return isUserAllowedByRoles(rolesNeeded.roles);
  }

  // PERMISSION DEFINED BY LVL
  if (rolesNeeded && rolesNeeded.lvl !== null) {
    return isUserAllowedByLvl(rolesNeeded);
  }

  // PERMISSION DEFINED BY IS CONNECTED
  if (rolesNeeded && rolesNeeded.auth) {
    // The check if token expired done in router
    return !!store.getters['account/token']; // return true if have a token
  }

  // NO PERMISSION DEFINED
  return true; // pages public so return true
};

export const isOrganizationUser = () => {
  return store.getters['account/roles'].includes(ROLES.ORGANIZATION_USER);
};

export const isPowerUser = () => {
  return store.getters['account/roles'].includes(ROLES.POWER_USER);
};

export const isAdministrator = () => {
  return store.getters['account/roles'].includes(ROLES.ADMINISTRATOR);
};

export const isConnected = () => {
  return !!store.getters['account/token'];
};

export const isPowerUserOrAdministrator = () => {
  return isConnected() && (isPowerUser() || isAdministrator());
};

export const canUserAccessPrivateData = () => {
  return (
    isConnected() &&
    (isOrganizationUser() || isPowerUser() || isAdministrator())
  );
};
